import React from 'react';
import { useTranslation } from 'react-i18next';
import PRODUCT_TYPES from '../../constants/productTypes';
import PAYMENT_TYPES from '../../constants/paymentTypes';

const SelectedProductCard = ({ productDetailData, item, selectedPaymentType }) => {
  const { t } = useTranslation();

  return (
    <div className='selected-product-card'>
      <div className='selected-product-top-group'>
        <p className={'selected-product-title'}>{productDetailData.title}</p>
        <p className={'selected-product-desc'}>
          {productDetailData.product_type === PRODUCT_TYPES.VIDEO ? productDetailData.title : null}
          {productDetailData.product_type === PRODUCT_TYPES.DIGITAL ? item.item_name : null}
        </p>
      </div>
      <div className='selected-product-bottom-group'>
        <div className='quantity-group'>
          <span className={'quantity-label'}>{t('quantity')} : </span>
          <span className={'quantity-info'}>
            {productDetailData.product_type === PRODUCT_TYPES.VIDEO ? '1' : null}
            {productDetailData.product_type === PRODUCT_TYPES.DIGITAL ? item.count : null}
          </span>
        </div>
        <p className='price-group'>
          {/* 스타비트 아이콘 표기 */}
          {selectedPaymentType === PAYMENT_TYPES.STAR_BEAT ? (
            <span className={'price-icon-group'}>
              <i className={'icon icon-star-point'} />
            </span>
          ) : null}
          {/* 비디오 가격 */}
          {productDetailData.product_type === PRODUCT_TYPES.VIDEO && selectedPaymentType !== PAYMENT_TYPES.STAR_BEAT
            ? productDetailData.price?.toLocaleString()
            : null}
          {/* 비디오 스타비트 가격 */}
          {productDetailData.product_type === PRODUCT_TYPES.VIDEO && selectedPaymentType === PAYMENT_TYPES.STAR_BEAT
            ? productDetailData.price_starbeat?.toLocaleString()
            : null}
          {/* 디지털 가격 */}
          {productDetailData.product_type === PRODUCT_TYPES.DIGITAL && selectedPaymentType !== PAYMENT_TYPES.STAR_BEAT
            ? (item.item_price * item.count).toLocaleString()
            : null}
          {/* 디지털 스타비트 가격 */}
          {productDetailData.product_type === PRODUCT_TYPES.DIGITAL && selectedPaymentType === PAYMENT_TYPES.STAR_BEAT
            ? (item.item_price_starbeat * item.count).toLocaleString()
            : null}
          {/* 통화 표기 */}
          {selectedPaymentType !== PAYMENT_TYPES.STAR_BEAT ? <>&nbsp;{productDetailData.currency}</> : null}
        </p>
      </div>
    </div>
  );
};

export default SelectedProductCard;
